<template>
  <div
    class="relative  bg-white dark:bg-gray-800 rounded-lg shadow"
  >
    <slot />
  </div>
</template>

<script>
export default {
  //
}
</script>
